export const cards = [
  {
    key: "woocommerce",
    title: "WooCommerce",
    url: "https://developers.klasha.com/plugins-and-sdks/plugins#woocommerce",
    description:
      "WooCommerce is an open-source e-commerce plugin for WordPress. It is designed for small to large-sized online merchants using WordPress.",
  },
];

export const FilterByTitle = (title) => {
  const newList = cards.filter((card) =>
    card.title.toLowerCase().includes(title.toLowerCase())
  );
  return newList;
};
